module.exports = "<input\n    #input\n    type=\"text\"\n    [id]=\"id\"\n    [name]=\"name\"\n    [placeholder]=\"placeholder\"\n    [required]=\"required\"\n    class=\"form-control\"\n/>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/telefone-input/telefone-input.component.html
// module id = ./src/app/common/telefone-input/telefone-input.component.html
// module chunks = main